<template>
  <div class="header-nav clearfix">
    <div class="logo fl">
      <img
        src="~@/assets/images/logo-icon.png"
        alt=""
      >
      <span class="logo-title">智慧心育</span>
    </div>
    <div class="nav-list fl">
      <div
        v-for="(it, index) in meunList"
        :key="index"
        class="nav-list-li"
      >
        <div class="list-item axe-dropdown">
          <div
            class="axe-dropdown-link axe-dropdown-selfdefine"
            :class="{'current': it.topbar === $route.meta.topbar}"
            @click="changePath(it.path)"
          >
            {{ it.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="nav-right fr clearfix">
      <div
        class="go-back"
        @click="goBack()"
      />
      <!-- <div class="user-list fl">
        <span class="user">
          <span class="user-photo">
            <img :src="defaultUserPhoto">
          </span>
          <span class="user-name">
            <span class="name ellipsis">{{ userInfo.userName }}</span>
            <i class="el-icon-caret-bottom" />
          </span>
        </span>
        <div class="setting-box">
          <div
            class="logout"
            @click="clickOut"
          >
            退出登录
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {},
  data () {
    return {
      msgCount: 0,
      defaultUserPhoto: require('@/assets/images/userPhoto.png'),
      meunList: [
        {
          "title": "心育课程",
          "url": "#",
          "id": 3,
          "target": "_self",
          "funcname": "testfunction",
          "path": "/curriculumResource",
          "topbar": "curriculum"
        },
        {
          "title": "心育测评",
          "url": "#",
          "target": "_self",
          "funcname": "testfunction",
          "path": "/measure/inventoryList",
          "topbar": "measurement"
        },
        {
          "title": "心育档案",
          "url": "#",
          "target": "_self",
          "funcname": "testfunction",
          "path": "/growthPortfolio",
          "topbar": "psychic"
        },
        {
          "title": "本校画像",
          "url": "#",
          "target": "_self",
          "funcname": "testfunction",
          "path": "/school",
          "topbar": "growth"
        }
      ],
      userInfo: { "userName": "xyls003", "userPhoto": "https://test.download.cycore.cn/edc/2022/02/10/16/10/19/82c0ddc8-12b1-44c5-a8d3-1b95ad7762c4.png" },
    };
  },
  computed: {
  },
  watch: {},
  created () { },
  mounted () { },
  methods: {
    goBack () {
      this.$router.push('/evaluationReport')
    },
    changePath (path) {
      if (path) {
        this.$router.push(path);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header-nav {
  width: 100%;
  min-width: 950px;
  height: 48px;
  line-height: 48px;
  background: #fff;
  .logo {
    padding-left: 24px;
    img {
      display: inline-block;
      width: 30px;
      height: 30px;
      vertical-align: middle;
    }
    .logo-title {
      // color: #fff;
      color: #595959;
      max-width: 15vw;
      font-size: 14px;
      font-weight: bold;
      margin-left: 8px;
    }
  }
  .nav-list {
    margin-left: 46px;
    .list-item {
      padding: 0 24px;
    }
    .axe-dropdown-link {
      cursor: pointer;
      color: #595959;
      font-size: 14px;
      .el-icon--right {
        font-size: 12px;
      }
      &:hover {
        // color: #fff;
        color: #368fff;
      }
      &.current {
        color: #368fff;
      }
    }
    .nav-list-li {
      display: inline-block;
    }
  }
}

.axe-dropdown-menu__item {
  text-align: center;
  width: 130px;
  &:hover {
    color: #368fff;
  }
}
.nav-Lists {
  //   left: 140px !important;
  ::v-deep.popper__arrow {
    left: 50% !important;
  }
}
.nav-right {
  position: relative;
  padding-right: 14px;

  .go-back {
    width: 100px;
    // background-color: red;
    height: 100px;
  }

  .user-home {
    padding: 0 10px;
    height: 48px;
    img {
      vertical-align: sub;
    }
  }
  .msg-icon {
    height: 48px;
    padding: 0 10px;
    font-size: 16px;
    /deep/.el-badge__content.is-fixed {
      top: 10px;
    }
  }
  .setting {
    position: relative;
    cursor: pointer;
    .lists {
      right: 0;
      top: 100%;
    }
    .lists-li {
      top: -1px;
      right: 100%;
    }
    .right-label-box {
      position: relative;
    }
    .set-list {
      position: absolute;
      display: none;
      font-size: 14px;
      background: #fff;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);
      border-radius: 4px;
      border: 1px solid #dedede;
      border-bottom: 0;
      white-space: nowrap;
      z-index: 3;
      min-width: 100%;
      .span-title {
        min-width: 180px;
        line-height: 36px;
        float: none;
        min-width: 70px;
        border-radius: 4px;
        margin: 0;
        border-bottom: 0.5px solid #ccc;
        position: relative;
        text-align: center;
        padding: 0 20px;
        i {
          margin-right: 2px;
          vertical-align: middle;
        }
        &:hover {
          color: #368fff;
        }
      }
    }
    &:hover {
      .lists {
        display: block;
      }
      .set-show {
        display: block;
        &:hover {
          .lists-li {
            display: block;
          }
        }
      }
    }
  }
  .ebginav {
    color: rgba(255, 255, 255, 0.85);
    // color: #595959;
    font-size: 16px;
  }
  .user {
    padding: 0 10px;
  }
  .user-photo {
    display: inline-block;
    width: 30px;
    height: 30px;
    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
      border-radius: 50%;
      display: inline-block;
      border: 1px solid #f0f0f0;
    }
  }
  .user-name {
    font-size: 14px;
    // color: #fff;
    .el-icon-caret-bottom {
      // color: rgba(255, 255, 255, 0.85);
      color: #595959;
      font-size: 13px;
    }
    .name {
      display: inline-block;
      vertical-align: middle;
      max-width: 70px;
      margin: 0 4px 0 8px;
    }
  }
}
.user-list {
  .setting-box {
    position: absolute;
    display: none;
    font-size: 14px;
    background: #fff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    border: 1px solid #dedede;
    white-space: nowrap;
    z-index: 10;
    // min-width: 100%;
    // width: px;
    right: 15px;
    .user-info {
      text-align: center;
      img {
        vertical-align: middle;
        margin: 0 auto;
        width: 60px;
        height: 60px;
        display: inline-block;
        border-radius: 50%;
        border: 1px solid #f0f0f0;
      }
      .name {
        line-height: 30px;
      }
    }
    .logout {
      color: #368fff;
      text-align: center;
      cursor: pointer;
      line-height: 40px;
      padding: 0 12px;
      &:hover {
        background: #eaf3ff;
      }
    }
  }
  &:hover {
    .setting-box {
      display: block;
    }
  }
}
.current {
  color: #368fff;
}
</style>
